import { businessBlocksArray } from '../functions';


export default class Template {
  constructor(store, stage, id, templateInfo) {
    this.store = store;
    this.stage = stage;
    this.id = id;
    this.automaticBlocks = [];
    this.initBlocks(templateInfo);
  }

  initBlocks(templateInfo) {
    this.maxCards = {};
    for (const [key, value] of Object.entries(templateInfo)) {
      this.maxCards[key] = value.cards;
      if (value.automatic) {
        this.automaticBlocks.push(key);
      }
    }
  }

  cards(block) {
    const result = [];
    if (this.isAutomatic(block) || !this.isValid(block)) {
      return [];
    }
    for (let cardIndex = 0; cardIndex < this.maxCards[block]; cardIndex++) {
      const cardCode = `${this.stage}_${this.id}_${block}_${cardIndex}`;
      result.push({ name: `${cardCode}_name`, description: `${cardCode}_description` });
    }
    return result;
  }

  get blocksInfo() {
    const result = {};
    for (const block of businessBlocksArray()) {
      result[block] = { automatic: false, cards: this.cards(block) };
    }
    return result;
  }

  isAutomatic(block) {
    return this.automaticBlocks.includes(block);
  }

  isValid(block) {
    return businessBlocksArray().includes(block);
  }
}
